"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversationOpenApiDocs = void 0;
const ConversationSchema = {
    type: 'object',
    properties: {
        id: { type: 'number' },
        title: { type: 'string' },
        uid: { type: 'string' },
        lastActivity: { type: 'string', format: 'date-time' },
        active: { type: 'boolean' },
        longAnswers: { type: 'boolean' },
        created_at: { type: 'string', format: 'date-time' },
        updated_at: { type: 'string', format: 'date-time' },
        allowedUsers: {
            type: 'array',
            items: { type: 'number' }
        },
        favorite: { type: 'boolean', description: 'Indicates if this conversation is favorited by the current user' },
        lastMessage: {
            type: 'object',
            properties: {
                id: { type: 'number' },
                content: { type: 'string' },
                fromUser: { type: 'boolean' },
                created_at: { type: 'string', format: 'date-time' }
            }
        },
        model: {
            type: 'object',
            properties: {
                id: { type: 'number' },
                name: { type: 'string' },
                provider: { type: 'string' }
            }
        },
        user: {
            type: 'object',
            properties: {
                id: { type: 'number' },
                name: { type: 'string' },
                username: { type: 'string' },
                email: { type: 'string' }
            }
        },
        messages: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'number' },
                    content: { type: 'string' },
                    message_type: {
                        type: 'string',
                        enum: ['text', 'image', 'file', 'system']
                    },
                    used_model: { type: 'string' },
                    reasoning: { type: 'string' },
                    fromUser: { type: 'boolean' },
                    citations: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                ref: { type: 'number' },
                                text: { type: 'string' }
                            }
                        }
                    },
                    tools: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                name: { type: 'string' },
                                data: { type: 'object' },
                                inputData: { type: 'object' }
                            }
                        }
                    },
                    attachments: {
                        type: 'array',
                        items: { type: 'string' }
                    },
                    files: {
                        type: 'array',
                        items: { type: 'number' }
                    },
                    editedAt: { type: 'string', format: 'date-time' },
                    created_at: { type: 'string', format: 'date-time' },
                    user: {
                        type: 'object',
                        properties: {
                            id: { type: 'number' },
                            name: { type: 'string' },
                            username: { type: 'string' },
                            email: { type: 'string' }
                        }
                    }
                }
            }
        },
        favoriteBy: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'number' },
                    user: {
                        type: 'object',
                        properties: {
                            id: { type: 'number' },
                            name: { type: 'string' },
                            username: { type: 'string' },
                            email: { type: 'string' }
                        }
                    }
                }
            }
        },
        selectedUsers: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'number' },
                    name: { type: 'string' },
                    username: { type: 'string' },
                    email: { type: 'string' }
                }
            }
        }
    }
};
const MessageSchema = {
    type: 'object',
    properties: {
        id: { type: 'number' },
        text: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    value: { type: 'string' },
                    followingSteps: {
                        type: 'array',
                        items: { type: 'string' }
                    }
                }
            }
        },
        citations: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    ref: { type: 'number' },
                    text: { type: 'string' }
                }
            }
        },
        tools: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    toolName: { type: 'string' },
                    data: { type: 'object' }
                }
            }
        },
        followupQuestions: {
            type: 'array',
            items: { type: 'string' }
        },
        model: { type: 'string' },
        user: {
            type: 'object',
            nullable: true,
            properties: {
                id: { type: 'number' },
                name: { type: 'string' },
                username: { type: 'string' },
                email: { type: 'string' }
            }
        },
        isUserMessage: { type: 'boolean' },
        timestamp: { type: 'string', format: 'date-time' },
        error: {
            type: 'object',
            properties: {
                message: { type: 'string' }
            }
        },
        thoughts: { type: 'string' },
        dataPoints: {
            type: 'array',
            items: { type: 'string' }
        },
        rawContent: { type: 'string' },
        files: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'number' },
                    name: { type: 'string' },
                    size: { type: 'number' },
                    type: { type: 'string' }
                }
            }
        },
        costs: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    promptTokens: { type: 'number' },
                    completionTokens: { type: 'number' },
                    totalTokens: { type: 'number' },
                    cost: { type: 'number' }
                }
            }
        }
    }
};
const ConversationListResponseSchema = {
    type: 'object',
    properties: {
        success: { type: 'boolean' },
        data: {
            type: 'array',
            items: ConversationSchema
        },
        count: { type: 'number' },
        error: { type: 'string' },
        error_code: {
            type: 'integer',
            description: 'Error code for programmatic handling'
        }
    },
    required: ['success']
};
const ConversationResponseSchema = {
    type: 'object',
    properties: {
        success: { type: 'boolean' },
        data: ConversationSchema,
        error: { type: 'string' },
        error_code: {
            type: 'integer',
            description: 'Error code for programmatic handling'
        }
    },
    required: ['success']
};
const ChatConversationResponseSchema = {
    type: 'object',
    properties: {
        success: { type: 'boolean' },
        data: {
            type: 'object',
            properties: {
                messages: {
                    type: 'array',
                    items: MessageSchema
                },
                conversation: ConversationSchema
            }
        },
        error: { type: 'string' },
        error_code: {
            type: 'integer',
            description: 'Error code for programmatic handling'
        }
    },
    required: ['success']
};
const AddShareUserPayloadSchema = {
    type: 'object',
    properties: {
        convoId: {
            type: 'number',
            description: 'ID of the conversation to share'
        },
        users: {
            type: 'array',
            items: { type: 'number' },
            description: 'Array of user IDs to share the conversation with'
        }
    },
    required: ['convoId', 'users']
};
exports.conversationOpenApiDocs = {
    'conversation.list': {
        description: 'Get paginated list of conversations with optional search',
        responses: {
            200: {
                description: 'List of conversations retrieved successfully',
                content: {
                    'application/json': {
                        schema: ConversationListResponseSchema
                    }
                }
            },
            401: {
                description: 'Unauthorized - authentication required',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            500: {
                description: 'Internal server error',
                returnParams: {
                    success: { type: 'boolean' },
                    error: { type: 'string' }
                }
            }
        }
    },
    'conversation.for-user': {
        description: 'Get all conversations for a specific user (returns same format as conversation.list)',
        responses: {
            200: {
                description: 'User conversations retrieved successfully',
                content: {
                    'application/json': {
                        schema: ConversationListResponseSchema
                    }
                }
            },
            401: {
                description: 'Unauthorized - authentication required',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            403: {
                description: 'Access denied - insufficient permissions',
                returnParams: {
                    success: { type: 'boolean' },
                    error: { type: 'string' },
                    error_code: { type: 'integer' }
                }
            }
        }
    },
    'conversation.get': {
        description: 'Get a single conversation by ID',
        responses: {
            200: {
                description: 'Conversation retrieved successfully',
                content: {
                    'application/json': {
                        schema: ConversationResponseSchema
                    }
                }
            },
            401: {
                description: 'Unauthorized - authentication required',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            403: {
                description: 'Access denied - insufficient permissions',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            404: {
                description: 'Conversation not found',
                returnParams: {
                    error: { type: 'string' }
                }
            }
        }
    },
    'conversation.get-chat': {
        description: 'Get conversation with all messages for chat interface',
        responses: {
            200: {
                description: 'Chat conversation retrieved successfully',
                content: {
                    'application/json': {
                        schema: ChatConversationResponseSchema
                    }
                }
            },
            401: {
                description: 'Unauthorized - authentication required',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            403: {
                description: 'Access denied - insufficient permissions',
                returnParams: {
                    success: { type: 'boolean' },
                    error: { type: 'string' }
                }
            },
            404: {
                description: 'Conversation not found',
                returnParams: {
                    error: { type: 'string' }
                }
            }
        }
    },
    'conversation.share': {
        description: 'Get shared conversation by unique identifier (public access)',
        responses: {
            200: {
                description: 'Shared conversation retrieved successfully',
                content: {
                    'application/json': {
                        schema: ChatConversationResponseSchema
                    }
                }
            },
            404: {
                description: 'Shared conversation not found',
                returnParams: {
                    error: { type: 'string' }
                }
            }
        }
    },
    'conversation.add_share_user': {
        description: 'Share conversation with specific users',
        payload: {
            body: AddShareUserPayloadSchema
        },
        responses: {
            200: {
                description: 'Conversation shared successfully',
                content: {
                    'application/json': {
                        schema: ConversationResponseSchema
                    }
                }
            },
            401: {
                description: 'Unauthorized - authentication required',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            403: {
                description: 'Forbidden - only conversation owners can share conversations',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            404: {
                description: 'Conversation not found',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            402: {
                description: 'Payment required - chat thread sharing feature not available',
                returnParams: {
                    error: { type: 'string' }
                }
            }
        }
    },
    'conversation.delete': {
        description: 'Delete a conversation (owner only)',
        responses: {
            200: {
                description: 'Conversation deleted successfully',
                content: {
                    'application/json': {
                        schema: ConversationResponseSchema
                    }
                }
            },
            401: {
                description: 'Unauthorized - authentication required',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            403: {
                description: 'Forbidden - only conversation owners can delete conversations',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            404: {
                description: 'Conversation not found',
                returnParams: {
                    error: { type: 'string' }
                }
            }
        }
    },
    'conversation.toggle-favorite': {
        description: 'Toggle favorite status of a conversation',
        responses: {
            200: {
                description: 'Conversation favorite status toggled successfully',
                content: {
                    'application/json': {
                        schema: ConversationResponseSchema
                    }
                }
            },
            401: {
                description: 'Unauthorized - authentication required',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            403: {
                description: 'Access denied - insufficient permissions',
                returnParams: {
                    error: { type: 'string' }
                }
            },
            404: {
                description: 'Conversation not found',
                returnParams: {
                    error: { type: 'string' }
                }
            }
        }
    }
};
